/**
 * Cuándo se puede importar un CSV de contactos.
 *
 * VIVE FUERA DEL JSX para que sea comprobable. La regla tiene consecuencia jurídica
 * —decide cuándo se registra una declaración de consentimiento— y dentro del render
 * no habría forma de ejercerla sin montar el componente entero, que este repo no
 * hace en ningún sitio.
 *
 * ESTO NO ES LA PROTECCIÓN, ES LA COMODIDAD. El backend valida lo mismo en
 * `functions/declararConsentimiento.js`, porque una petición a mano puede omitir
 * ambas cosas. Si algún día las dos reglas divergen, la que manda es la del backend.
 */

/**
 * Las finalidades que el negocio puede declarar, en el orden en que se muestran.
 *
 * Los valores tienen que coincidir con `FINALIDADES_VALIDAS` del backend
 * (`functions/integrations/campanas/declaracionConsentimiento.js`): son lo que viaja
 * en la petición. Si alguien añade una aquí y no allí, el backend la descartará en
 * silencio y el negocio creerá haber declarado algo que no se guardó.
 */
export const FINALIDADES_UI = ['servicio', 'publicidad'];

/**
 * @param {boolean} declaracionAceptada
 * @param {string[]} finalidades
 * @returns {boolean}
 */
export function puedeImportarContactos(declaracionAceptada, finalidades) {
  // LAS DOS COSAS. Aceptar la declaración sin seleccionar ninguna finalidad no
  // significa nada: el texto dice «para las finalidades seleccionadas», y sin ninguna
  // esa frase no afirma nada. Y seleccionar finalidades sin aceptar la declaración es
  // no haber declarado.
  return declaracionAceptada === true
    && Array.isArray(finalidades)
    && finalidades.some((f) => FINALIDADES_UI.includes(f));
}
